// /src/pages/Terms.js
import React from 'react';
import { Container, Row, Col, Card } from "react-bootstrap";

export default function Terms() {
  return (
    <div className="explore-page" style={{ minHeight: "100vh" }}>
      <div className="star-field">
        {Array.from({ length: 100 }).map((_, i) => (
          <div
            key={i}
            className="star"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`
            }}
          />
        ))}
      </div>

      <Container fluid className="py-5">
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <div className="text-center mb-5">
              <img 
                src="/sparkthinking.png"
                alt="AniSpark Mascot" 
                className="mascot-image mb-4"
                style={{
                  width: '120px',
                  height: '120px',
                  filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.3))'
                }}
              />
              <h1 className="text-light mb-3" style={{ fontSize: '3rem', fontWeight: '700' }}>
                Terms and Conditions
              </h1>
              <p className="text-light" style={{ fontSize: '1.2rem', opacity: 0.9 }}>
                <strong>Last Updated:</strong> June 13, 2025
              </p>
            </div>

            <Row className="g-4">
              <Col md={12}>
                <Card 
                  className="mb-4"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-5">
                    <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '1.8rem', fontWeight: '600' }}>
                      1. Acceptance of Terms
                    </h2>
                    <p className="text-light" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                      By accessing or using AniSpark, you agree to comply with and be bound by these Terms and Conditions. If you do not agree, please do not use the platform.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      2. User Accounts
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      To access certain features, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and all activities that occur under your account.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      3. Creator Content
                    </h3>
                    <p className="text-light mb-3" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      Creators may upload short-form anime content to be showcased on the platform. You retain ownership of your content but grant AniSpark a license to host and display it on the platform.
                    </p>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      All content must comply with AniSpark's guidelines. Explicit pornographic content is not allowed and will be removed. NSFW content must be appropriately flagged.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      4. Monetization and Donations
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      AniSpark allows creators to add donation links (e.g., Patreon or Ko-fi) to their profiles. AniSpark does not currently take a commission on these links, but you are subject to the terms of the third-party services.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      5. Advertisements
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      AniSpark may display ads (e.g., Google AdSense or Carbon Ads) to support the platform. These third parties may use cookies or similar tracking technologies.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={12}>
                <Card 
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-5">
                    <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '1.8rem', fontWeight: '600' }}>
                      6. Prohibited Activities
                    </h2>
                    <ul className="text-light" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                      <li className="mb-2">Uploading copyrighted material you do not own or have permission to use</li>
                      <li className="mb-2">Uploading harmful, illegal, or exploitative content</li>
                      <li className="mb-2">Harassing or impersonating other users</li>
                      <li className="mb-2">Bypassing security features or attempting to disrupt the platform</li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      7. Account Termination
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      AniSpark reserves the right to suspend or terminate your account if you violate these Terms or act in a way that harms the platform or its community.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card 
                  className="h-100"
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-4">
                    <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                      8. Changes to Terms
                    </h3>
                    <p className="text-light" style={{ opacity: 0.9, lineHeight: '1.7' }}>
                      We may update these Terms from time to time. Material changes will be communicated through the platform. Continued use of AniSpark means you accept the updated terms.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={12}>
                <Card 
                  style={{ 
                    backgroundColor: "rgba(30, 27, 75, 0.8)", 
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)"
                  }}
                >
                  <Card.Body className="p-5 text-center">
                    <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                      9. Contact
                    </h2>
                    <p className="text-light" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                      For any questions regarding these Terms, please contact us at{' '}
                      <strong style={{ color: '#facc15' }}>support@anispark.co</strong>
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .explore-page {
          background: linear-gradient(135deg, #1e1b4b 0%, #3c366b 100%);
          position: relative;
          overflow: hidden;
        }
        
        .star-field {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          z-index: 1;
        }
        
        .container-fluid {
          position: relative;
          z-index: 2;
        }

        .star {
          position: absolute;
          width: 2px;
          height: 2px;
          background: white;
          border-radius: 50%;
          animation: twinkle 3s ease-in-out infinite;
        }
        
        @keyframes twinkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }

        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        }

        .mascot-image {
          animation: float 3s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </div>
  );
}